export const jobEmploymentTypesEn = {
  jobEmploymentTypes: {
    'full_time': 'Full-time',
    'part_time': 'Part-time',
    'contract': 'Contract',
    'freelance': 'Freelance',
    'temporary': 'Temporary',
    'internship': 'Internship',
    'seasonal': 'Seasonal'
  }
};
